module.exports = new __parcel__URL__("ConfluenceStandardOfferCalendarModalRightSide.cde5ac5e.svg").toString();